module.exports = __webpack_public_path__ + "img/excel.16c7f2b8.png";